import { Component, OnInit, ViewChild } from '@angular/core';
import { UntypedFormBuilder, UntypedFormGroup, Validators } from '@angular/forms';
import { TranslateService } from '@ngx-translate/core';
import { CommonService } from '@tech-services/common.service';
import { LoginService } from '@tech-services/login.service';
import { TechDialogsService } from '../../shared/tech-dialogs.service';
import { MatButton } from '@angular/material/button';
import { faSpinner, IconDefinition } from '@fortawesome/pro-solid-svg-icons';
import { Subject, takeUntil } from 'rxjs';
import { AppConfig } from '@tech-utils/app-config.service';

@Component({
  selector: 'tech-register',
  templateUrl: './register.component.html',
  styleUrls: ['./register.component.scss']
})
export class RegisterComponent implements OnInit {
  @ViewChild('btnSend', { static: true }) btnSend: MatButton;
  public domain: string = localStorage.getItem('Domain');
  public customTheme = localStorage.getItem('ThemeImg');


  public form: UntypedFormGroup;
  public faSpinner: IconDefinition = null;
  public mailResult: boolean;
  public logoUrl =
    './assets/img/' +
    localStorage.getItem('ThemeImg') +
    '/WealthRules-265px.png';
  private unsubscribe$ = new Subject<void>();
  public backEffect: boolean = JSON.parse(AppConfig.settings.backgroundEffect);
  public img = 'FondoLogin.jpg';
  
  constructor(
        private fb: UntypedFormBuilder,
        private loginService: LoginService,
        private commonService: CommonService,
        private translate: TranslateService,
        private dialogService: TechDialogsService
    
  ) {
    this.form = this.fb.group({
      user: ['', [Validators.required, Validators.email]],
    });
  }

  ngOnInit(): void {
    this.randomBackgroundImage();
    this.mailResult = false;
  }

  ngOnDestroy(): void {
    this.unsubscribe$.next(null);
    this.unsubscribe$.complete();
  }
  onSendEmail() {
    this.faSpinner = faSpinner;
    this.commonService.loading$.emit(true);

    this.commonService
      .getAppSetting()
      .pipe(takeUntil(this.unsubscribe$))
      .subscribe((data) => {
        localStorage.setItem('Language', data.language);
        localStorage.setItem('Domain', data.domain);
      });

    const form = this.form.value;
    this.loginService
      .sendRegisterClient(
        form.user
      )
      .subscribe(
        (data) => {
          this.form.reset();
          this.mailResult = true;
          this.faSpinner = null;
          this.commonService.loading$.emit(false);
        },
        (err) => {
          this.form.reset();
          this.faSpinner = null;
          this.commonService.loading$.emit(false);
          this.mailResult = true;
        }
      );

  }

  public randomBackgroundImage() {
    let numberImages = 12;
    let includeCero = false;
    let min = includeCero ? 0 : 1;
    let number = Math.floor(Math.random() * (numberImages - min)) + min;
    this.img =
      number < 10
        ? 'FondoLogin_0' + number + '.jpg'
        : 'FondoLogin_' + number + '.jpg';
  }
}
